import { Action } from "@ngrx/store";
import {
  Category,
  ComboSpec,
  GenericError,
  Product,
  Store,
} from "@tendercuts/models";
import { OutofStockProducts } from "../../models";

/**
 * Onfailed carries information to do postmortem
 */
export class ActionCatalogLoadFailed implements Action {
  readonly type = "ACTION_CATALOG_LOAD_FAIL";

  constructor(public payload: GenericError) {}
}

/**
 * Action trigger on load success
 */
export class ActionCatalogLoadSuccess implements Action {
  readonly type = "ACTION_CATALOG_LOAD_SUCCESS";

  constructor(public payload: Category[]) {}
}

/**
 * Action to trigger the server request
 */
export class ActionCatalogLoad implements Action {
  readonly type = "ACTION_CATALOG_LOAD";

  /**
   *
   * @param {Store} Tendercuts store model
   */
  constructor(public payload: Store) {}
}

/**
 * Noop action to use in case when no actions are needed to be triggered
 */
export class ActionNoop implements Action {
  readonly type = "ACTION_NOOP";

  constructor() {}
}

/**
 * Action to trigger the search request
 */
export class ActionSearchProducts implements Action {
  readonly type = "ACTION_SEARCH_PRODUCTS";

  /**
   *
   * @param {String} search string
   */
  constructor(public payload: String) {}
}

/**
 * Action to set the filtered products into the state.
 */
export class ActionSearchComplete implements Action {
  readonly type = "ACTION_SEARCH_COMPLETE";

  /**
   *
   * @param {String} search string
   */
  constructor(public payload: Product[]) {}
}

/**
 * Action to set the filtered products into the state.
 */
export class ActionLoadComboLinks implements Action {
  readonly type = "ACTION_LOAD_COMBO_LINKS";

  /**
   *
   * @param {String} search string
   */
  constructor(public payload: { [id: number]: ComboSpec[] }) {}
}

/**
 * Action is to fetch the out of stock products for the current store.
 */
export class ActionFetchOutOfStockProduct implements Action {
  readonly type = "ACTION_FETCH_OUTOFSTOCK_PRODUCT";

  constructor(public storeId: number) {}
}

/**
 * Action is to set the out of stock products into the state
 */
export class ActionLoadOutofStockProducts implements Action {
  readonly type = "Action_LOAD_OUTOFSTOCK_Products";

  constructor(public oosProducts: OutofStockProducts[]) {}
}

/**
 * Action triggers on failed response
 */
export class ActionLoadOutofStockFailed implements Action {
  readonly type = "ACTION_LOAD_OUTOFSTOCK_FAILED";

  constructor(public err: GenericError) {}
}

/**
 * Action triggers on elite products fetch from firebase
 */
export class ActionEliteCatalogLoadSuccess implements Action {
  readonly type = "ACTION_ELITE_CATALOG_LOAD_SUCCESS";

  constructor(public eliteProducts: Product[]) {}
}
